import { Link, useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft, FileText, ShieldCheck, Users } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { TERMS_TEXT, PRIVACY_TEXT, GUIDELINES_TEXT } from "@/lib/legal";

const TABS = [
  { path: "/termos", key: "terms", label: "Termos de Uso", icon: FileText, body: TERMS_TEXT },
  { path: "/privacidade", key: "privacy", label: "Política de Privacidade", icon: ShieldCheck, body: PRIVACY_TEXT },
  { path: "/regras", key: "guidelines", label: "Regras da Comunidade", icon: Users, body: GUIDELINES_TEXT },
];

export default function Legal() {
  const loc = useLocation();
  const nav = useNavigate();
  const { t } = useLang();
  const active = TABS.find((x) => x.path === loc.pathname) || TABS[0];

  return (
    <div className="page fade-up">
      <button
        onClick={() => nav(-1)}
        data-testid="legal-back"
        className="inline-flex items-center gap-1 text-sm text-zinc-500 py-3 hover:text-black"
      >
        <ArrowLeft size={14} /> Voltar
      </button>

      <div className="flex overflow-x-auto gap-2 pb-2 -mx-4 px-4 scrollbar-none mb-4">
        {TABS.map(({ path, key, label, icon: I }) => (
          <Link
            key={key}
            to={path}
            data-testid={`legal-tab-${key}`}
            className="chip whitespace-nowrap"
            data-active={active.key === key}
          >
            <I size={12} />
            {label}
          </Link>
        ))}
      </div>

      <article
        data-testid={`legal-content-${active.key}`}
        className="bg-white rounded-2xl border border-zinc-200 p-5 sm:p-6 mb-8 prose-legal"
      >
        <header className="mb-4 pb-4 border-b border-zinc-100">
          <div className="text-[10px] uppercase tracking-[0.15em] text-[#c8102e] font-bold mb-1">ANGOLAUK+</div>
          <h1 className="font-display text-2xl sm:text-3xl font-extrabold leading-tight">{active.label}</h1>
        </header>
        <div
          className="text-sm text-zinc-700 leading-relaxed space-y-3 whitespace-pre-line"
          dangerouslySetInnerHTML={{ __html: active.body }}
        />
        <p className="mt-6 pt-4 border-t border-zinc-100 text-[11px] text-zinc-500 leading-relaxed">
          Contacto: <a href="mailto:support@angolauk.co.uk" className="text-[#c8102e] underline">support@angolauk.co.uk</a>
          <br />
          Operado por CD NOIR LTD, registada em Inglaterra e País de Gales.
        </p>
      </article>
    </div>
  );
}
